"use client";

import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { excursionTerms } from "@/lib/excursionTerms";
const BENEFITS = ["Private hotel transfer", "Prices on request", "Direct WhatsApp enquiries", excursionTerms.en.chip];
export default function WhyBookWithUs() {
  return <section id="whybookwithus" data-nav="light" className="bg-background text-foreground py-6 sm:py-8 border-b border-border/60">
      <div className="max-w-[1136px] mx-auto px-6">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        ease: "easeOut"
      }} className="flex flex-wrap items-center justify-center gap-2.5 sm:gap-3 lg:gap-4">
          {BENEFITS.map((benefit, index) => <div key={benefit} data-index={index} className="inline-flex items-center gap-2.5 px-4 py-2 sm:py-2.5 rounded-lg bg-card border border-border text-foreground text-xs sm:text-sm font-medium shadow-2xs hover:border-primary/40 transition-colors duration-200">
              <span className="flex items-center justify-center size-5 rounded-lg bg-primary/20 text-primary shrink-0">
                <Check className="size-3.5 stroke-[2.5]" aria-hidden="true" />
              </span>
              <span>{benefit}</span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}